'use client';

import { Fragment } from 'react';
import { Container } from '@/components/common/container';
import { DatenqualitaetContent } from '@/app/(protected)/datenqualitaet/content';

export default function DatenqualitaetPageClient() {
  return (
    <Fragment>
      <Container>
        <DatenqualitaetContent />
      </Container>
    </Fragment>
  );
}
